import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckCircle, User, Phone, AtSign, Lock } from 'lucide-react';
import { AuthShell, AuthField, PasswordField, AuthButton, AuthAlert } from '../components/auth/AuthShell';
import { useAuthStore } from '../store/auth';

export const Register: React.FC = () => {
  const navigate = useNavigate();
  const { register, isLoading } = useAuthStore();
  const [form, setForm] = useState({ name: '', phone: '', username: '', password: '' });
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const update = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (form.password !== confirm) {
      setError('Parollar mos kelmadi');
      return;
    }
    if (form.password.length < 6) {
      setError('Parol kamida 6 belgidan iborat bo\'lishi kerak');
      return;
    }

    try {
      const message = await register(form);
      setSuccess(message);
    } catch (err: any) {
      setError(err.message || 'Ro\'yxatdan o\'tishda xato');
    }
  };

  if (success) {
    return (
      <AuthShell
        title="Ariza qabul qilindi"
        subtitle={success}
        footer={
          <Link to="/login" className="text-primary-800 font-semibold">
            Kirish sahifasiga qaytish
          </Link>
        }
      >
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-full bg-success-100 flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-success-600" />
          </div>
        </div>
        <button
          onClick={() => navigate('/login')}
          className="w-full h-14 rounded-2xl bg-primary-600 hover:bg-primary-700 active:bg-primary-active text-white text-base font-semibold shadow-lg shadow-primary-600/25 transition-colors"
        >
          Kirish sahifasiga
        </button>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Ro'yxatdan o'tish"
      compact
      subtitle="Ariza bering — admin tasdiqlagach do'kon ocha olasiz"
      footer={
        <>
          Hisobingiz bormi?{' '}
          <Link to="/login" className="text-primary-800 font-semibold">
            Kirish
          </Link>
        </>
      }
    >
      {error && <AuthAlert tone="error">{error}</AuthAlert>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <AuthField
          id="name"
          label="To'liq ism"
          icon={User}
          value={form.name}
          onChange={update('name')}
          placeholder="Ism Familiya"
          autoComplete="name"
          autoCapitalize="words"
          enterKeyHint="next"
          required
        />
        <AuthField
          id="phone"
          label="Telefon"
          icon={Phone}
          type="tel"
          inputMode="tel"
          value={form.phone}
          onChange={update('phone')}
          placeholder="+998 90 123 45 67"
          autoComplete="tel"
          enterKeyHint="next"
          required
        />
        <AuthField
          id="reg-username"
          label="Login"
          icon={AtSign}
          value={form.username}
          onChange={update('username')}
          placeholder="Foydalanuvchi nomi"
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          enterKeyHint="next"
          required
        />
        <PasswordField
          id="reg-password"
          label="Parol"
          icon={Lock}
          value={form.password}
          onChange={update('password')}
          placeholder="Kamida 6 ta belgi"
          autoComplete="new-password"
          enterKeyHint="next"
          required
        />
        <PasswordField
          id="reg-confirm"
          label="Parolni tasdiqlang"
          icon={Lock}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          placeholder="Parolni qayta kiriting"
          autoComplete="new-password"
          enterKeyHint="send"
          required
        />

        <div className="pt-2">
          <AuthButton loading={isLoading} loadingText="Yuborilmoqda...">
            Ariza berish
          </AuthButton>
          <p className="mt-3 text-center text-sm text-gray-500">
            Ariza berish orqali{' '}
            <Link to="/privacy" className="text-primary-800 font-medium">maxfiylik siyosati</Link>
            ga rozilik bildirasiz
          </p>
        </div>
      </form>
    </AuthShell>
  );
};
